<template>
	<div>
		<div class="d-flex justify-content-between">
			<label class="font-weight-bold">Fecha ganó:</label>
	        <a href="#" v-on:click.prevent="showFecha()" v-if="!editField && hasAdmin">
	        	<i class="fas fa-edit"></i>
	        </a>
	    </div>

		<div class="input-group flex-nowrap" v-if="editField">
			<date-picker type="text" placeholder="Fecha" aria-label="Fecha ganó" aria-describedby="button-addFecha" v-model="fecha_fin" :disabled="loading"></date-picker>
			<div class="input-group-append" id="button-addFecha">
				<button class="btn btn-outline-light" type="button" v-on:click="save()" :disabled="loading">
					<i class="fas fa-check text-success"></i>
				</button>
				<button class="btn btn-outline-light" type="button" v-on:click="cancel()" :disabled="loading">
					<i class="fas fa-times text-danger"></i>
				</button>
			</div>
		</div>
		<div v-else>
			<input disabled class="form-control" v-model="fecha_fin">
		</div>
	</div>
</template>
<script>
	export default {
		props:['oportunidad', 'fecha'],
		data(){
			return {
				fecha_fin: '',
				editField: false,
				loading: false,
			}
		},

		created(){
			this.fecha_fin = this.fechaDF
		},

		methods: {
			showFecha(){
				this.editField = true
			},

			hideFecha(){
				this.editField = false
			},

			cancel(){
				this.hideFecha()
				this.fecha_fin = this.fechaDF
			},

			save(){
				this.loading = true
				axios.post(`api/oportunidades/${this.oportunidadDF}/fechaFin`, {
					fecha_fin: this.fecha_fin
				}).then(res=>{
					this.$toasted.info('La fecha ha sido actualizada')
					this.hideFecha()
				}).catch(err => {
					if (err.response) {
						if (typeof err.response.data === 'string') {
							this.$toasted.error(err.response.data)
							return;
						}
					}
					console.log(err)
					console.log(err.response)
					this.$toasted.error('Error al actualizar la fecha')
				}).then(() => {
					this.loading = false
				})
			}
		},

		computed: {
			oportunidadDF(){
				return this.oportunidad
			},

			fechaDF(){
				return moment(this.fecha).format('DD-MM-YYYY')
			},

			hasAdmin(){
				var permission = this.configuracion.OPORTUNIDADES_EDIT_FECHA_FIN || ''
				var permissionArr = permission.split(',')
				return permissionArr.includes(crm.role)
			},
			configuracion(){
				return this.configuracionBase()
			},
		},

		watch: {
			fechaDF: function(val){
				this.fecha_fin = val
			}
		}
	}
</script>